import { Link } from "react-router-dom";
import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useHomeData } from "../../../lib/useMockData";

export default function AboutSection() {
  const { aboutData } = useHomeData();
  return (
    <section className="py-20 md:py-28 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-5xl mx-auto text-center">
          <ScrollReveal direction="up">
            <p className="section-label mb-3">{aboutData.label}</p>
            <h2 className="section-title">{aboutData.title}</h2>
            <p className="mt-8 text-base md:text-lg text-airdoa-gray leading-[1.9] max-w-3xl mx-auto">
              {aboutData.description}
            </p>
          </ScrollReveal>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
            {aboutData.points.map((point, idx) => (
              <ScrollReveal key={point.title} direction="up" delay={idx * 100}>
                <div className="p-7 md:p-8 bg-airdoa-cream rounded-lg">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center text-airdoa-gold mb-5">
                    <i className={`${point.icon} text-2xl`} />
                  </div>
                  <h3 className="text-base font-serif font-semibold text-airdoa-navy">
                    {point.title}
                  </h3>
                  <p className="mt-3 text-sm text-airdoa-gray leading-relaxed">{point.desc}</p>
                </div>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal direction="up" delay={300}>
            <div className="mt-12">
              <Link to="/company" className="text-sm text-airdoa-gold hover:text-airdoa-gold-dark transition-colors duration-300 underline underline-offset-4 decoration-airdoa-gold/40 hover:decoration-airdoa-gold">
                AIRDOAの運営会社について
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}